module.exports = __webpack_public_path__ + "static/media/mcafee.e002eeaa.png";